import styled from 'styled-components';
import media from 'styled-media-query';

import { TableContainer } from 'components/DefaultTable/styles';
import colors from 'themes/Main';

const { gray03, warning, danger, pink, success } = colors;

export const Table = styled(TableContainer)`
  thead tr th:nth-child(2),
  thead tr th:nth-child(3),
  tbody tr td:nth-child(2),
  tbody tr td:nth-child(3) {
    text-align: center;
  }

  td > div {
    margin-left: 8px;
  }

  tr th:first-child,
  tr th:last-child {
    cursor: pointer;

    > svg {
      margin-left: 4px;
    }
  }

  td:hover > div > div:nth-child(2) {
    display: block;
  }

  tr td[class^='status'] {
    font-weight: 700;
  }

  th,
  td {
    padding: 15px;
  }

  .status-,
  .status-refused,
  .status-incomplete {
    font-weight: 600;
    color: ${danger};
  }

  .status-not-pointed {
    color: ${warning};
  }

  .status-pending {
    color: ${pink};
  }

  .status-approved {
    color: ${success};
  }
`;

export const RefreshButton = styled.button`
  background-color: transparent;
  border: 0;
`;

export const CallbackContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 64px;
`;

export const CallbackText = styled.h2`
  width: 500px;
  margin-top: 32px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: ${gray03};
  text-align: center;

  ${media.lessThan('medium')`
    width: 100vw;
    padding: 0 32px;
  `}
`;
